<div class="modal" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<div class="form-floating mb-3">
					<select
						class="form-select"
						id="ownerType"
						name="ownerType"
						[(ngModel)]="data.ownerType"
						(change)="ownerTypeSelected()"
					>
						<option value="">(wybierz)</option>
						<option [value]="item.id" *ngFor="let item of ownersTypes">
							{{ item.name }}
						</option>
					</select>
					<label for="ownerType">Rodzaj właściciela</label>
				</div>
				<div class="form-floating mb-3" *ngIf="data.ownerType">
					<select class="form-select" id="ownerId" name="ownerId" [(ngModel)]="data.ownerId">
						<option value="">(wybierz)</option>
						<option [value]="item.id" *ngFor="let item of ownersIds">
							{{ item.name }}
						</option>
					</select>
					<label for="ownerType">Właściciel</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="date"
						class="form-control"
						name="dateFrom"
						id="dateFrom"
						[(ngModel)]="data.dateFrom"
						[readonly]="isItemBefore"
					/>
					<label for="dateFrom">Data wydania</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="date"
						class="form-control"
						name="dateTo"
						id="dateTo"
						[(ngModel)]="data.dateTo"
						[readonly]="isItemAfter"
					/>
					<label for="dateTo">Data zwrotu</label>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="submit()">Zapisz</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">
					Anuluj
				</button>
			</div>
		</div>
	</div>
</div>

<app-dynamic-table
	[elements]="owners"
	[tableRows]="tableRows"
	[haveLink]="false"
	[haveButton]="true"
	(buttonClicked)="selectOwner($event)"
></app-dynamic-table>
